import DialogModal from "../../atoms/dialog";
import NotificationSelectionForm from "./form";
import { defaultNotificationFormValues } from "./helper";

type Props = {
    handleClose: () => void
    isOpen: boolean
    data?: typeof defaultNotificationFormValues
    handleDataChange: (data: any) => Promise<void>
}

export default function NotificationSelectionDialog({ handleClose, isOpen, data, handleDataChange } : Props) {
    return (
        <DialogModal
            title={"Notifications"}
            handleClose={handleClose}
            isOpen={isOpen}
        >
            <NotificationSelectionForm
                handleClose={handleClose}
                data={data}
                handleDataChange={handleDataChange}
            />
        </DialogModal>
    )
}